(() => {
  function initBundle(root) {
    if (!root || root.dataset.bundleInitialized === 'true') return;
    root.dataset.bundleInitialized = 'true';

    const sectionId = root.id.replace('BundleQuantity-', '');
    const mapScript = document.querySelector(`script[data-bundle-variant-map="${sectionId}"]`);
    if (!mapScript) return;

    let data;
    try {
      data = JSON.parse(mapScript.textContent);
    } catch (e) {
      return;
    }

    const tiers = Array.from(root.querySelectorAll('.bundle-quantity__tier'));
    const radios = Array.from(root.querySelectorAll('.bundle-quantity__radio'));
    const productFormId = root.dataset.productFormId;
    const form = productFormId ? document.getElementById(productFormId) : null;

    function selectTier(tier) {
      tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const tier = radio.closest('.bundle-quantity__tier');
        selectTier(tier);
      });
    });

    function updateThumb(row) {
      const colorSelect = row.querySelector('[data-bundle-color-select]');
      const thumb = row.querySelector('[data-bundle-thumb]');
      if (!colorSelect || !thumb) return;
      const url = data.colorImages[colorSelect.value];
      if (url) {
        thumb.src = url;
        thumb.alt = colorSelect.value;
      }
    }

    root.querySelectorAll('.bundle-quantity__variant-row').forEach((row) => {
      updateThumb(row);
      const colorSelect = row.querySelector('[data-bundle-color-select]');
      if (colorSelect) {
        colorSelect.addEventListener('change', () => updateThumb(row));
      }
    });

    // Row 0 of every tier mirrors whatever color/talla is currently chosen
    // in the main variant picker above, so the shopper only has to fill in
    // the *extra* units of the pack — not re-pick the one they already
    // selected. Later rows stay independent.
    const colorInputName = root.dataset.colorInputName;
    const sizeInputName = root.dataset.sizeInputName;

    // Dawn's own variant-option radios render with a stray trailing newline
    // baked into their name="" attribute (a pre-existing quirk elsewhere in
    // the theme), so an exact [name="..."] match never hits — match on the
    // trimmed name instead of relying on the raw attribute value.
    //
    // Option names/positions ("Color-1", "Talla-2"...) are NOT unique across
    // the page: any other product rendered nearby (a "related products"
    // carousel card, a quick-add modal) that happens to share the same
    // option name/position gets radios with the exact same name="" — and
    // those can appear in the DOM *after* page load (quick-add content is
    // fetched lazily). A plain document-wide querySelectorAll would then
    // pick up a stranger product's radio instead of this product's own, so
    // every lookup here is scoped to radios whose form="" attribute points
    // at THIS product's own add-to-cart form.
    function scopedRadios(name) {
      if (!productFormId) return [];
      return Array.from(
        document.querySelectorAll(`input[type="radio"][form="${productFormId}"]`)
      ).filter((input) => input.name.trim() === name);
    }

    function findRadioByName(name) {
      if (!name) return null;
      return scopedRadios(name).find((input) => input.checked) || null;
    }

    function getMainSelection() {
      const colorInput = findRadioByName(colorInputName);
      const sizeInput = findRadioByName(sizeInputName);
      return {
        color: colorInput ? colorInput.value : null,
        size: sizeInput ? sizeInput.value : null,
      };
    }

    function syncFirstRowToMainSelection() {
      const { color, size } = getMainSelection();
      if (!color && !size) return;
      root.querySelectorAll('.bundle-quantity__variant-row').forEach((row) => {
        const colorSelect = row.querySelector('[data-bundle-color-select][data-row="0"]');
        const sizeSelect = row.querySelector('[data-bundle-size-select][data-row="0"]');
        if (colorSelect && color && Array.from(colorSelect.options).some((o) => o.value === color)) {
          colorSelect.value = color;
        }
        if (sizeSelect && size && Array.from(sizeSelect.options).some((o) => o.value === size)) {
          sizeSelect.value = size;
        }
        if (colorSelect && colorSelect.dataset.row === '0') updateThumb(colorSelect.closest('.bundle-quantity__variant-row'));
      });
    }

    // Changing ANY option (size, color) makes Dawn's native variant picker
    // refetch the product section and re-render its own markup in place —
    // so it can grey out combinations that become unavailable — which
    // destroys and recreates the color/size radio *elements themselves*.
    // A listener bound directly to those elements (as this used to do)
    // goes silent the moment that happens: the new radios are perfectly
    // functional but carry no listener of ours. Delegating the listener to
    // `document` sidesteps this entirely, since it never cares which
    // physical node dispatched the event — only its name/form attributes,
    // read fresh off `event.target` every time.
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || target.type !== 'radio' || target.getAttribute('form') !== productFormId) return;
      const name = target.name.trim();
      if (name === colorInputName || name === sizeInputName) {
        syncFirstRowToMainSelection();
      }
    });

    syncFirstRowToMainSelection();

    function getSelectedQty() {
      const checked = radios.find((r) => r.checked);
      return checked ? parseInt(checked.value, 10) : 1;
    }

    function buildBundleItems(qty) {
      const items = [];
      for (let i = 0; i < qty; i++) {
        const colorSelect = root.querySelector(
          `[data-bundle-color-select][data-tier="${qty}"][data-row="${i}"]`
        );
        const sizeSelect = root.querySelector(
          `[data-bundle-size-select][data-tier="${qty}"][data-row="${i}"]`
        );
        if (!colorSelect || !sizeSelect) return null;
        const key = `${colorSelect.value}|${sizeSelect.value}`;
        const variant = data.variants[key];
        if (!variant || !variant.available) return null;
        items.push({ id: variant.id, quantity: 1 });
      }
      return items;
    }

    if (form) {
      // Capture phase (the "true" below) is essential: the theme's own
      // product-form handler also listens for "submit" on this same form
      // and calls stopImmediatePropagation(), which would silently block
      // a normal (bubble-phase) listener of ours from ever running. By
      // listening in the capture phase we run BEFORE the theme's handler
      // gets a chance to, so we can take over the multi-unit case cleanly.
      form.addEventListener(
        'submit',
        (event) => {
          const qty = getSelectedQty();
          if (qty <= 1) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const items = buildBundleItems(qty);
          if (!items) {
            window.alert('Alguna combinación de color y talla elegida no está disponible. Revisa tu selección.');
            return;
          }

          const submitButton = form.querySelector('[type="submit"]');
          if (submitButton) submitButton.setAttribute('disabled', 'disabled');

          fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
            .then(({ ok, json }) => {
              if (!ok) {
                throw new Error(json.description || 'No se pudo añadir el pack al carrito.');
              }
              if (submitButton) submitButton.removeAttribute('disabled');

              // Refresh the drawer's own HTML with the cart state we just
              // created BEFORE opening it — otherwise it opens showing
              // whatever stale markup it had at page load (e.g. "empty"),
              // since a raw cart/add.js call bypasses Dawn's normal
              // product-form flow that keeps the drawer in sync.
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(json);
              } else {
                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) {
                  cartIcon.click();
                } else {
                  window.location.reload();
                }
              }
            })
            .catch((error) => {
              window.alert(error.message || 'No se pudo añadir el pack al carrito.');
              if (submitButton) submitButton.removeAttribute('disabled');
            });
        },
        true
      );
    }
  }

  function guardBundle(root) {
    if (!root || root.dataset.bundleGuarded === 'true') return;
    root.dataset.bundleGuarded = 'true';

    const clone = root.cloneNode(true);
    const formId = root.dataset.productFormId;
    let current = root;
    let checks = 0;

    // Some apps (size charts, trust badges, etc.) rebuild a chunk of this
    // area of the page after load and can wipe out sibling elements they
    // don't know about — including our block. A MutationObserver on the
    // immediate parent isn't enough if a bigger ancestor gets replaced
    // wholesale, so instead we just poll for a few seconds and put the
    // block back, anchored to the add-to-cart form itself (the one thing
    // no app can remove, or nothing on the page could be purchased).
    const interval = window.setInterval(() => {
      checks += 1;

      if (!document.body.contains(current)) {
        const form = formId ? document.getElementById(formId) : null;
        if (form && form.parentNode) {
          const restored = clone.cloneNode(true);
          restored.dataset.bundleInitialized = 'false';
          restored.dataset.bundleGuarded = 'true';
          form.parentNode.insertBefore(restored, form);
          initBundle(restored);
          current = restored;
        }
      }

      if (checks >= 24) window.clearInterval(interval);
    }, 500);
  }

  function initAllGuarded() {
    document.querySelectorAll('[data-bundle-quantity]').forEach((root) => {
      initBundle(root);
      guardBundle(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGuarded);
  } else {
    initAllGuarded();
  }

  document.addEventListener('shopify:section:load', initAllGuarded);
})();
